// Polyfill findDOMNode for react-transition-group compatibility with React 19.
// React 19 removed findDOMNode but react-transition-group v4 still imports it.
// All CSSTransitions use nodeRef so this is never actually called — it just
// prevents the import from crashing.
// eslint-disable-next-line
const reactDom = require('react-dom');
if (!reactDom.findDOMNode) {
	reactDom.findDOMNode = function () { return null; };
}
